var _line, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#3872B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-list",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 21,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 21,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 21,
    y2: 18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3.01,
    y2: 6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3.01,
    y2: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 3.01,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.c01fae8b24b8ddb7bc56f98b83bc0326.svg";
export { ForwardRef as ReactComponent };